import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LayoutIcon, SettingsIcon, SmartphoneIcon } from 'lucide-react';
import { PageCTA } from '../components/PageCTA';
const services = [{
  number: '01',
  icon: LayoutIcon,
  title: 'Web que sitúa tu valor en primer plano',
  description: 'Construimos una experiencia editorial y comercial para que quien llega entienda tu negocio, sus servicios y el siguiente paso sin perderse.',
  includes: ['Arquitectura de contenidos', 'Diseño responsive', 'Páginas clave para conversión'],
  visual: ['Propuesta clara', 'Servicios ordenados', 'Contacto visible']
}, {
  number: '02',
  icon: SmartphoneIcon,
  title: 'Carta digital que facilita elegir',
  description: 'Una carta o catálogo móvil que reúne lo importante en un formato claro, visual y más sencillo de actualizar que un documento estático.',
  includes: ['Experiencia mobile-first', 'Categorías y productos', 'Acceso mediante QR'],
  visual: ['Consulta desde móvil', 'Información actualizable', 'Lectura sin fricción']
}, {
  number: '03',
  icon: SettingsIcon,
  title: 'Gestión para que publicar no sea el final',
  description: 'La entrega incluye una base que se puede cuidar. Acompañamos los cambios necesarios para mantener tu presencia útil y coherente.',
  includes: ['Actualizaciones de contenido', 'Mantenimiento técnico', 'Soporte continuo'],
  visual: ['Base mantenida', 'Cambios acompañados', 'Sin cuotas ocultas']
}];
export function ServicesPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] pt-24" data-id="element-639" data-mp="32im7bsl7b4y6">
      <section className="border-b border-white/10 py-16 sm:py-24" data-id="element-640" data-mp="2w5t36atq7fv">
        <div className="container mx-auto max-w-6xl px-6 md:px-12" data-id="element-641" data-mp="2xgwh50cxd6g">
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="max-w-3xl" data-id="element-642" data-mp="3u8qpdklhnfw8">
            <p className="eyebrow" data-id="element-643" data-mp="1imf0rf6z6asl">Servicios</p>
            <h1 className="mt-5 text-4xl font-medium tracking-[-0.055em] text-white sm:text-6xl" data-id="element-644" data-mp="1nlrm1vi779t2">
              Una presencia digital que trabaja como un todo.
            </h1>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-neutral-400 sm:text-lg" data-id="element-645" data-mp="19omm8d92v769">
              No acumulamos entregables aislados. Cada pieza se construye para
              reforzar la misma experiencia: explicar mejor tu valor y hacer más
              simple el siguiente paso.
            </p>
          </motion.div>
        </div>
      </section>

      {services.map((service, index) => {
      const Icon = service.icon;
      return <section key={service.number} className="border-b border-white/10 py-16 sm:py-24" aria-labelledby={`service-${service.number}`} data-id="element-646" data-mp="2yzwscv5vvvrk" data-mpi={index}>
            <div className="container mx-auto max-w-6xl px-6 md:px-12" data-id="element-647" data-mp="ift5le04u8ba">
              <div className={`grid gap-10 lg:grid-cols-2 lg:gap-16 ${index % 2 === 1 ? 'lg:[&>div:first-child]:order-2' : ''}`} data-id="element-648" data-mp="x4652kyfi9aj">
                <motion.div initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.3
            }} transition={{
              duration: 0.5
            }} data-id="element-649" data-mp="sauuq9ueradv">
                  <div className="flex items-center gap-4" data-id="element-650" data-mp="3huohp9g45a98">
                    <span className="text-[10px] font-medium tracking-[0.22em] text-neutral-600" data-id="element-651" data-mp="3cv26t6nrc63l">
                      {service.number}
                    </span>
                    <span className="h-px w-10 bg-white/20" data-id="element-652" data-mp="3ee24tuf83knp" />
                  </div>
                  <div className="mt-9 flex h-12 w-12 items-center justify-center border border-white/15 text-white" data-id="element-653" data-mp="3j9hhwk5epcj2">
                    <Icon size={22} aria-hidden="true" data-id="element-654" data-mp="3o82k2p47y6a5" />
                  </div>
                  <h2 id={`service-${service.number}`} className="mt-7 text-3xl font-medium tracking-[-0.04em] text-white sm:text-4xl" data-id="element-655" data-mp="3t8gqk2q69862">
                    {service.title}
                  </h2>
                  <p className="mt-5 max-w-xl text-sm leading-relaxed text-neutral-400 sm:text-base" data-id="element-656" data-mp="35j46g7tb3foz">
                    {service.description}
                  </p>
                  <ul className="mt-8 space-y-3 border-t border-white/10 pt-6" data-id="element-657" data-mp="3ac74ot913dbi">
                    {service.includes.map(item => <li key={item} className="flex items-center gap-3 text-sm text-neutral-300" data-id="element-658" data-mp="2ht9vxwwgm37w">
                        <CheckIcon size={15} className="text-white" aria-hidden="true" data-id="element-659" data-mp="uxdf42mjjgxg" />
                        {item}
                      </li>)}
                  </ul>
                </motion.div>
                <motion.div initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.3
            }} transition={{
              duration: 0.5,
              delay: 0.08
            }} className="flex min-h-[320px] items-end border border-white/10 bg-black p-7 sm:p-9" data-id="element-660" data-mp="g0me5ox7xx5q">
                  <div className="w-full" data-id="element-661" data-mp="3es0soj6hw856">
                    <p className="text-[10px] font-medium uppercase tracking-[0.2em] text-neutral-600" data-id="element-662" data-mp="3eqz5jgc7fv73">
                      Vista conceptual
                    </p>
                    <div className="mt-8 border border-white/10" data-id="element-663" data-mp="35sng3hn2r3g8">
                      {service.visual.map((item, visualIndex) => <div key={item} className="flex items-center justify-between border-b border-white/10 p-4 last:border-b-0" data-id="element-664" data-mp="39va1azp8pq4g" data-mpi={visualIndex}>
                          <span className="text-sm text-neutral-300" data-id="element-665" data-mp="6ebeihueznma">
                            {item}
                          </span>
                          <span className="text-[10px] font-medium tracking-[0.18em] text-neutral-600" data-id="element-666" data-mp="3sr9x6llc9dtb">
                            0{visualIndex + 1}
                          </span>
                        </div>)}
                    </div>
                    <p className="mt-5 text-xs leading-relaxed text-neutral-500" data-id="element-667" data-mp="p4t5agvos950">
                      La dirección final se adapta a las necesidades, tono y
                      materiales de cada negocio.
                    </p>
                  </div>
                </motion.div>
              </div>
            </div>
          </section>;
    })}
      <PageCTA data-id="element-668" data-mp="2elevydk07xlr" />
    </div>;
}